import styled from 'styled-components';
export const OptionWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  width: 100%;
  background: ${({ theme, isSelected }) => (isSelected ? theme.colors.grey05_1 : theme.colors.grey00_6)};
  cursor: pointer;
  white-space: normal;
  word-break: break-word;
  gap: 4px;

  &:hover {
    background: ${({ theme }) => theme.colors.grey05_1};
  }
`;
export const CheckmarkWrapper = styled.span `
  display: flex;
  flex: 0 0 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
`;
